import { render, staticRenderFns } from "./ApiSettings.vue?vue&type=template&id=34a28df4&scoped=true"
import script from "./ApiSettings.vue?vue&type=script&lang=js"
export * from "./ApiSettings.vue?vue&type=script&lang=js"
import style0 from "./ApiSettings.vue?vue&type=style&index=0&id=34a28df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a28df4",
  null
  
)

export default component.exports